export default __webpack_public_path__ + "media/images/group-meal-14efac529ed311e8ecac14819c7b6afd.png";